// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2t2UT","summary-link":"_3MbHU","summary":"_2dXQH"};